import React from "react";
import PageTransition from "../Components/PageTransition";
import AnimatedHero from "../Components/AnimatedHero";
export default function PrivacyPolicy() {
  return (
    <PageTransition className="testimonials-page background">
      <AnimatedHero
        title="Privacy Policy"
        subtitle="Darvik Foundation respects your privacy and is committed to protecting
        your personal information."
        className="about-hero"
        overlayColor="rgba(14,77,109,0.15)"
      />
    <div className="container py-5">
      <h3>1. Information We Collect</h3>
      <p>
        We collect donor details including name, phone number, email, PAN (if
        provided), and address for issuing receipts, providing updates, and
        complying with legal requirements.
      </p>

      <h3>2. Use of Information</h3>
      <p>
        Your data is used only for donation processing, tax exemption receipts,
        and communication related to our activities. We never sell or misuse
        your information.
      </p>

      <h3>3. Payment Security</h3>
      <p>
        All payments are processed securely through Razorpay. We do not store
        sensitive payment details like card or UPI information.
      </p>

      <h3>4. Data Protection</h3>
      <p>
        Reasonable technical and organizational measures are taken to protect
        your data from unauthorized access or misuse.
      </p>

      <h3>5. Contact Us</h3>
      <p>
        For any questions about this policy, please contact us at:{" "}
        <a href="mailto:darvikfoundation22@gmail.com">
          darvikfoundation22@gmail.com
        </a>
      </p>
    </div>
    </PageTransition>
  );
}
